<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' ,fullScreenBackdrop:true}">
</ngx-loading>
<div class="wrapper">
    <app-sidebar></app-sidebar>
    <app-header></app-header>

    <div class="page-wrapper">
        <div class="page-content">
            <!--breadcrumb-->
            <div class="page-breadcrumb d-none d-sm-flex align-items-center mb-4">
                <div class="breadcrumb-title pe-3" >Community Detail</div>
                <div class="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb mb-0 p-0">
                            <li class="breadcrumb-item"><a href="javascript:void(0);" routerLink="/dashboard"><i class="bx bx-home-alt"></i></a>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page"  (click)="service.back()">Community </li>
                        </ol>
                    </nav>
                </div>
            </div>
            <!--end breadcrumb-->

            <div class="row">
                <div class="col-xl-11">
                    <div class="card border-top border-0 border-4 border-brand">
                        <div class="card-body p-5">
                            <div class="card-title d-flex align-items-center">
                                <div><i class="bx bxs-user me-1 font-22 brand-color"></i>
                                </div>
                                <h5 class="mb-0 brand-color"  (click)="service.back()">Community Detail</h5>
                            </div>
                            <hr>
                            <form  class="row">
                                <div class="col-md-12" *ngIf="imgURL !='' ">
                                    <div class="file-upload-output">
                                        <img [src]="imgURL" alt="Admin" style="height:50px;width:50px">
                                    </div>
                                </div>
                                <div class="col-6 pt-4">
                                    <div class="form-group pb-4">
                                        <label class="form-label m-0" for="Username">Name </label>
                                        <input type="text" class="form-control " id="Username" placeholder="Name" aria-describedby="errorEmail" [(ngModel)]="CurrentDetail.name" [ngModelOptions]="{standalone: true}" readonly disabled >
                                    </div>
                                </div>                                                             
                                <div class="col-6 pt-4">
                                    <div class="form-group pb-4">
                                        <label class="form-label m-0" for="Username"> Total Members  </label>
                                        <input type="text" class="form-control " id="Username" placeholder="Total Members" aria-describedby="errorEmail" [(ngModel)]="CurrentDetail.totalMember" [ngModelOptions]="{standalone: true}" readonly disabled >
                                    </div>
                                </div>
                                <div class="col-6">
                                    <div class="form-group pb-4">
                                        <label class="form-label m-0" for="Username"> Total Posts  </label>
                                        <input type="text" class="form-control " id="Username" placeholder="Total Posts" aria-describedby="errorEmail" [(ngModel)]="CurrentDetail.totalPost" [ngModelOptions]="{standalone: true}" readonly disabled >
                                    </div>
                                </div>
                                                           
                                
                                <div class="col-6">
                                    <div class="form-group pb-4">
                                        <label class="form-label m-0" for="Username"> Status </label>
                                        <input type="text" class="form-control " id="Username" placeholder="Name" aria-describedby="errorEmail" [(ngModel)]="CurrentDetail.status" [ngModelOptions]="{standalone: true}" readonly disabled >
                                    </div>
                                </div>  
                                <div class="col-6">
                                    <div class="form-group pb-4">
                                        <label class="form-label m-0" for="Username"> Description  </label>
                                        <textarea type="text" class="form-control" rows="3"  id="Username" placeholder="BIO" aria-describedby="errorEmail" [(ngModel)]="CurrentDetail.description" [ngModelOptions]="{standalone: true}" readonly disabled ></textarea>
                                    </div>
                                </div>                       
                                <div class="btn-box col-12 pt-4">
                                    <button type="submit" class="btn custom-btn dark-btn px-4 me-3" (click)="service.back()">Back</button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="card p-3" *ngIf="UserList.length !=0 || PostList.length !=0">
                        <div class="col-12 col-xl-11">
                            <div class="accordion-block">
                                <div class="accordion" id="accordionExample">
                                    <div class="accordion-item darksecundary-bg" >
                                        <h2 class="accordion-header" id="Social_Heading">
                                            <button class="accordion-button " type="button" data-bs-toggle="collapse" data-bs-target="#Social_Information" aria-expanded="true" aria-controls="Social_Information">
                                       Community Members Detail
                                    </button>
                                        </h2>
                                        <div id="Social_Information" class="accordion-collapse collapse show" aria-labelledby="Social_Heading">
                                            <div class="accordion-body custom-form custom-form-2">
                                                <div class="card-body  table-responsive">
                                                    <table class="table mb-0 table-hover">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">No.</th>                                       
                                                                <th scope="col">First Name</th>
                                                                <th scope="col">Last Name</th>  
                                                                <th scope="col">Email</th>
                                                                <th scope="col">Total Post</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody *ngIf="UserList.length !=0">
                                                            <tr *ngFor="let item of UserList | paginate: { itemsPerPage: pageLimit, currentPage: p, totalItems: totalCount, id: 's'} ; let i = index ">
                                                                <td scope="row">{{ (pageLimit * (p - 1)) + i + 1 }}</td>
                                                                <td>{{item.firstName}}</td>
                                                                <td >{{item.lastName}}</td>
                                                                <td >{{item.email}}</td>
                                                                <td >{{item.totalPost}}</td>                                                                                                                                              
                                                            </tr>
                                                        </tbody>
                                                        <tbody *ngIf="UserList.length ==0">
                                                            <tr>
                                                                <p class="text-center">Sorry, No Record Found</p>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <div class="pagination-block pt-5">
                                                        <pagination-controls [previousLabel]="previousLabel" [nextLabel]="nextLabel" id="s" (pageChange)="getMDetail((p = $event))" class="text-center" *ngIf="UserList.length > 0"></pagination-controls>
                                                    </div> 
                                                </div>
                                            </div>
                                        </div>
                                    </div>                                     
                                </div>                      
                            </div>
                            <div class="accordion-block pt-4">
                                <div class="accordion" id="accordionExample">
                                    <div class="accordion-item darksecundary-bg" >
                                        <h2 class="accordion-header" id="post_Heading">
                                            <button class="accordion-button " type="button" data-bs-toggle="collapse" data-bs-target="#Post_Information" aria-expanded="true" aria-controls="Post_Information">
                                        Community Post Detail
                                    </button>
                                        </h2>
                                        <div id="Post_Information" class="accordion-collapse collapse show" aria-labelledby="post_Heading">
                                            <div class="accordion-body custom-form custom-form-2">
                                                <div class="card-body  table-responsive">
                                                    <table class="table mb-0 table-hover">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">No.</th>                                       
                                                                <!-- <th scope="col">First Name</th> -->
                                                                <th scope="col">Content</th>  
                                                                <th scope="col">Description</th>
                                                                <th scope="col">Total Like</th>
                                                                <th scope="col">Total Comment</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody *ngIf="PostList.length !=0">
                                                            <tr *ngFor="let item of PostList | paginate: { itemsPerPage: pageLimit, currentPage: p1, totalItems: totalCount1,id: 'd'} ; let i = index ">
                                                                <td scope="row">{{(pageLimit * (p1 - 1)) +  i + 1 }}</td>
                                                                <!-- <td>{{item..firstName}}</td> -->
                                                                <td *ngIf="item.type==2"> <img [src]="item.content" style="height: 70px;width:70px;cursor: pointer;" (click)="largeView =item.content" data-bs-toggle="modal" data-bs-target="#Image_view1"></td>
                                                                <td *ngIf="item.type==1"> <video [src]="item.content"  disablePictureInPicture controlsList="noplaybackrate nodownload" type="video/*" style="height: 70px;width:70px" (click)="largeView=item.content" data-bs-toggle="modal" data-bs-target="#Video_view1"></video>
                                                                </td>
                                                                <td [title]="item.description">{{item.description | truncate:35}}</td>
                                                                <td >{{item.totalLikes}}</td>
                                                                <td >{{item.totalComment}}</td>                                                                                                                                              
                                                            </tr>
                                                        </tbody>
                                                        <tbody *ngIf="PostList.length ==0">
                                                            <tr>
                                                                <p class="text-center">Sorry, No Record Found</p>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <div class="pagination-block pt-5">
                                                        <pagination-controls [previousLabel]="previousLabel" id="d" [nextLabel]="nextLabel" (pageChange)="getPDetail((p1 = $event))" class="text-center" *ngIf="PostList.length > 0"></pagination-controls>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>                                     
                                </div>                      
                            </div>
                        </div>
                    </div>
            <!--end row-->

                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>

<div class="modal fade" id="Image_view1" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="qr-modal modal-dialog modal-dialog-centered">
        <div class="modal-content darksecundary-bg border-radius20">
            <div class="modal-body" id="thankyou-page-block">
                <div class="btn-box pt-2 text-end">
                    <a class="font-16" href="javascript:void(0);" (click)="close('#Image_view1')" class="close" data-dismiss="modal" title="Close"><i class='bx bx-x'></i></a>
                </div>
                <div class="px-3 pb-4 text-center">
                    <div class="mt-4 p-4 white-bg qr-code-img">
                        <img id="qr_code" loading="lazy" class="w-100" [src]="largeView" />
                    </div>
                </div>

            </div>

        </div>
    </div>
</div>

<div class="modal fade" id="Video_view1" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="qr-modal modal-dialog modal-dialog-centered">
        <div class="modal-content darksecundary-bg border-radius20">
            <div class="modal-body" id="thankyou-page-block">
                <div class="btn-box pt-2 text-end">
                    <a class="font-16" href="javascript:void(0);" (click)="close('#Video_view1')" class="close" data-dismiss="modal" title="Close"><i class='bx bx-x'></i></a>
                </div>
                <div class="px-3 pb-4 text-center">
                    <div class="file-upload-output">
                        <video [src]="largeView" class="w-100"  controls disablePictureInPicture controlsList="noplaybackrate nodownload" type="video/*"></video>
                    </div>
                    <!-- <div class="mt-4 p-4 white-bg qr-code-img">
                        <img id="qr_code" loading="lazy" class="w-100" [src]="largeView" />
                    </div> -->
                </div>

            </div>

        </div>
    </div>
</div>

